import React from 'react';

// Componente para a seção "Nossas Soluções"
const Solucoes: React.FC = () => {
  return (
    <section id="solucoes" className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title">Nossas Soluções Inovadoras</h2>
          <p className="section-subtitle">
            Desenvolvemos soluções personalizadas que transformam dados em inteligência acionável,
            impulsionando o crescimento e a eficiência do seu negócio.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Solução 1: Lupa Paranoá (Unificada) */}
          <div className="card group hover:-translate-y-2 transition-all duration-300 border-t-4 border-lupa-orange flex flex-col">
            <div className="h-16 w-16 rounded-full bg-lupa-orange/20 dark:bg-lupa-orange/10 flex items-center justify-center mb-6 group-hover:bg-lupa-orange/30 transition-all duration-300 self-start">
              {/* Ícone representando Data Lakehouse / Unificação */}
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Lupa Paranoá</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-6 flex-grow">
              {/* Placeholder para descrição unificada - será preenchido depois */}
              Nossa solução escalável para centralização e unificação de dados, adaptável a empresas de todos os portes.
            </p>
            <div className="mt-auto">
              <a href="/solucoes/lupa-paranoa" className="text-lupa-orange hover:text-lupa-orange-dark dark:text-lupa-orange-light dark:hover:text-lupa-orange font-medium flex items-center transition-colors">
                Saiba mais
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
          
          {/* Solução 2: Lupa Cast */}
          <div className="card group hover:-translate-y-2 transition-all duration-300 border-t-4 border-lupa-orange flex flex-col">
            <div className="h-16 w-16 rounded-full bg-lupa-orange/20 dark:bg-lupa-orange/10 flex items-center justify-center mb-6 group-hover:bg-lupa-orange/30 transition-all duration-300 self-start">
              {/* Ícone representando Forecast / IA */}
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Lupa Cast</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-6 flex-grow">
              {/* Placeholder para descrição - será preenchido depois */}
              Ferramenta de forecast de vendas com IA que permite conversas interativas com seus dados para decisões estratégicas.
            </p>
            <div className="mt-auto">
              <a href="/solucoes/lupa-cast" className="text-lupa-orange hover:text-lupa-orange-dark dark:text-lupa-orange-light dark:hover:text-lupa-orange font-medium flex items-center transition-colors">
                Saiba mais
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
          
          {/* Solução 3: LIA */}
          <div className="card group hover:-translate-y-2 transition-all duration-300 border-t-4 border-lupa-orange flex flex-col">
            <div className="h-16 w-16 rounded-full bg-lupa-orange/20 dark:bg-lupa-orange/10 flex items-center justify-center mb-6 group-hover:bg-lupa-orange/30 transition-all duration-300 self-start">
              {/* Ícone representando IA / Assistente */}
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">LIA (Lupa Inteligência Artificial)</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-6 flex-grow">
              {/* Placeholder para descrição - será preenchido depois */}
              IA conversacional adaptável, projetada para integração e atendimento inteligente em diversas plataformas.
            </p>
            <div className="mt-auto">
              <a href="/solucoes/lia" className="text-lupa-orange hover:text-lupa-orange-dark dark:text-lupa-orange-light dark:hover:text-lupa-orange font-medium flex items-center transition-colors">
                Saiba mais
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        {/* Botão "Ver todas as soluções" removido pois todas estão visíveis */}
      </div>
    </section>
  );
};

export default Solucoes;

